import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { parse } from "qs";
import Loading from "../../components/Loading";
import styles from "./styles.module.scss";
function Online() {
  const [state, setState] = useState(false);
  let locale = window.location.pathname.split("/")[1] || "zh-TW";
  const location = useLocation();
  const queryParams = useMemo(() => {
    return location.search ? parse(location.search.slice(1)) : {};
  }, [location.search]);

  useEffect(() => {
    const head_test = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");
    const langMap = {
      "en-US": "f9194e81-dd10-4286-9685-f7827cb4a3cd",
      "ja-JP": "715686e8-14da-4af7-bd8c-7cf08134460c",
      "zh-CN": "b90060f1-3eaf-4065-bcbc-74c7e2470810",
      "zh-TW": "b90060f1-3eaf-4065-bcbc-74c7e2470810",
      "ko-KR": "98a66986-83a6-4989-8eed-24ace34b944d",
      "zh-CN-VIP": "93c2edd5-d860-425e-bd4d-ac4e6e999039",
      "zh-TW-VIP": "93c2edd5-d860-425e-bd4d-ac4e6e999039",
      "ja-JP-VIP": "2a3a531c-7b36-4526-b919-d6b6be1417fc",
      "ko-KR-VIP": "1db56e39-5051-497b-bcec-9545295d3193",
      "en-US-VIP": "29bdccfb-04a7-49e9-ba91-c752d280f978",
    };
    let key = locale;
    if (queryParams.accountLevelName) {
      const index = queryParams.accountLevelName.match(/\d+$/gi);
      if (index) {
        const level = Number(index[0]);
        if (level >= 3) {
          key += "-VIP";
        }
      }
    }
    script.id = "ze-snippet";
    script.src =
      "https://static.zdassets.com/ekr/snippet.js?key=" + langMap[key];
    head_test.appendChild(script);
    script.onload = function (e) {
      window.zE("messenger:set", "locale", locale);
      window.zE("messenger", "open");
      const timer = setTimeout(() => {
        if (document.querySelector("body>div>iframe")) {
          const style = document.createElement("style");
          style.textContent =
            "button[class*='sc-htpNat sc-k22q4b-0 hDMtkw sc-EHOje'] {display:none}";
          document
            .querySelector("body>div>iframe")
            .contentDocument.querySelector("head")
            .appendChild(style);
        }
        clearTimeout(timer);
        setState(true);
      }, 1000);
    };
    return () => {
      clearTimeout(timer);
    };
  }, [locale, queryParams.accountLevelName]);

  return <div className={styles.loading}>{!state && <Loading />}</div>;
}

export default Online;



// WEBPACK FOOTER //
// ./src/pages/Online/index.js